var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.901,
    height: 45.417,
    viewBox: "0 0 36.901 45.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14ffa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15e584"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8685554_ic_fluent_bot_filled_icon",
    "data-name": "8685554_ic_fluent_bot_filled_icon",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M35.265,11.5A5.136,5.136,0,0,1,40.4,16.639V18.6h-.015A9.994,9.994,0,0,1,37.2,25.85c-2.714,2.476-7.4,4.095-15.248,4.095S9.416,28.326,6.7,25.85A9.993,9.993,0,0,1,3.515,18.6H3.5V16.639A5.136,5.136,0,0,1,8.636,11.5Z",
    transform: "translate(0 17.472)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M9.258,4.839A4.258,4.258,0,0,0,5,9.1V20.451a4.258,4.258,0,0,0,4.258,4.258h19.87a4.258,4.258,0,0,0,4.258-4.258V9.1a4.258,4.258,0,0,0-4.258-4.258H20.612V3.419A1.364,1.364,0,0,0,19.193,2a1.431,1.431,0,0,0-1.419,1.419V4.839Zm1.419,9.935a2.839,2.839,0,1,1,2.839,2.839A2.839,2.839,0,0,1,10.677,14.774Zm11.354,0a2.839,2.839,0,1,1,2.839,2.839A2.839,2.839,0,0,1,22.031,14.774Z",
    transform: "translate(2.758 0)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.4a98273ca00d5e18891f0f45b67b5017.svg";
export { ForwardRef as ReactComponent };